import { render, staticRenderFns } from "./EditMainCategory.vue?vue&type=template&id=36d984a7&scoped=true"
import script from "./EditMainCategory.vue?vue&type=script&lang=js"
export * from "./EditMainCategory.vue?vue&type=script&lang=js"
import style0 from "./EditMainCategory.vue?vue&type=style&index=0&id=36d984a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d984a7",
  null
  
)

export default component.exports